import './includes/form';
import './includes/scrollto';
import './includes/popups';
import './includes/placeholder';
import './includes/header';
import './includes/footer';
import './includes/cart';
import './includes/faq';
import './includes/helper';
import './includes/back-links';
import './includes/checkout';
import './includes/gallery';

window.addEventListener('load', () => {
  document.body.classList.add('page-loaded');
});
